import React from 'react';
import Icon from '../../../components/AppIcon';

const MSATabNavigation = ({ 
  activeTab = 'contract',
  onTabChange = () => {},
  tabs = [
    { id: 'contract', label: 'Contract', icon: 'FileText' },
    { id: 'documents', label: 'Documents', icon: 'FolderOpen' },
    { id: 'dates', label: 'Key Dates', icon: 'Calendar' },
    { id: 'signatures', label: 'Signatures', icon: 'PenTool' }
  ]
}) => {
  return (
    <div className="sticky top-16 z-40 bg-card border-b border-border">
      <div className="px-6 max-w-7xl mx-auto">
        <nav className="flex space-x-8" role="tablist">
          {tabs?.map((tab) => {
            const isActive = activeTab === tab?.id;
            
            return (
              <button
                key={tab?.id}
                role="tab"
                aria-selected={isActive}
                aria-controls={`${tab?.id}-panel`}
                className={`
                  relative flex items-center space-x-2 py-4 px-1 text-sm font-medium
                  transition-all duration-200 ease-out
                  focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2
                  ${isActive 
                    ? 'text-primary border-b-2 border-primary' :'text-muted-foreground hover:text-foreground border-b-2 border-transparent hover:border-border'
                  }
                `}
                onClick={() => onTabChange(tab?.id)}
              >
                <Icon 
                  name={tab?.icon} 
                  size={16} 
                  className={`transition-colors duration-200 ease-out ${
                    isActive ? 'text-primary' : 'text-muted-foreground'
                  }`}
                />
                <span>{tab?.label}</span>
                {isActive && (
                  <div className="absolute bottom-0 left-0 right-0 h-0.5 bg-primary rounded-t-sm" />
                )}
              </button>
            );
          })}
        </nav>
      </div>
    </div>
  );
};

export default MSATabNavigation;